import parcelTemplateSaga, {
  fetchParcelTemplates,
} from '~/sagas/parcel-template/parcel-template.saga';

export { fetchParcelTemplates };

export default parcelTemplateSaga;
